import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

type ErrorMessage = {
  errorMessage: null | string | Error;
  setErrorMessage: Dispatch<SetStateAction<null | string | Error>>;
};

const ErrorMessageContext = createContext<ErrorMessage | null>(null);

export function useErrorMessageProvider() {
  const ctx = useContext(ErrorMessageContext);
  if (!ctx) throw Error('Need to Set Context Value');
  return ctx;
}

export default function ErrorMessageProvider({
  children,
}: {
  children: ReactNode;
}) {
  const [errorMessage, setErrorMessage] = useState<null | string | Error>(null);

  useEffect(() => {
    if (!errorMessage) return;

    setTimeout(() => setErrorMessage(null), 5000);
  }, [errorMessage]);

  const errorMemoValues = useMemo(
    () => ({ errorMessage, setErrorMessage }),
    [errorMessage, setErrorMessage]
  );

  return (
    <ErrorMessageContext.Provider value={errorMemoValues}>
      {children}
    </ErrorMessageContext.Provider>
  );
}
